export default __webpack_public_path__ + "static/media/table_cancer_PC_Cn.57b0c3a2.webp";